import apiRequest from './apiConfig';
import { endpoints, apiVersion } from './endpoints';

const BASE_URL = process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.tenants;

export const getAllTenantsApi = () =>
  apiRequest({ method: 'get', url: BASE_URL });

export const addTenantApi = (payload) =>
  apiRequest({ method: 'post', url: BASE_URL, payload });

export const updateTenantApi = (id, payload) =>
  apiRequest({ method: 'put', url: `${BASE_URL}/${id}`, payload });

export const deleteTenantApi = (id) =>
  apiRequest({ method: 'delete', url: `${BASE_URL}/${id}` });
